import { _HasDataLoaderMeta } from 'unplugin-vue-router/runtime'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/app/src/pages/index.vue'),
    children: [
      {
        path: '',
        name: '//',
        component: () => import('/app/src/pages/index/index.vue'),
        /* no children */
      }
    ],
    meta: {
      "requiresAuth": true
    }
  },
  {
    path: '/:agent',
    name: '/[agent]',
    component: () => import('/app/src/pages/[agent].vue'),
    children: [
      {
        path: '',
        name: '/[agent]/',
        component: () => import('/app/src/pages/[agent]/index.vue'),
        /* no children */
      },
      {
        path: 'manage',
        name: '/[agent]/manage',
        component: () => import('/app/src/pages/[agent]/manage.vue'),
        /* no children */
      },
      {
        path: 'share',
        name: '/[agent]/share',
        component: () => import('/app/src/pages/[agent]/share.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/app/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/admin',
    name: '/admin',
    component: () => import('/app/src/pages/admin.vue'),
    children: [
      {
        path: 'manage-collection',
        /* internal name: '/admin/manage-collection' */
        /* no component */
        children: [
          {
            path: '',
            name: '/admin/manage-collection/',
            component: () => import('/app/src/pages/admin/manage-collection/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'manage-data',
        /* internal name: '/admin/manage-data' */
        /* no component */
        children: [
          {
            path: '',
            name: '/admin/manage-data/',
            component: () => import('/app/src/pages/admin/manage-data/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'manage-group',
        /* internal name: '/admin/manage-group' */
        /* no component */
        children: [
          {
            path: '',
            name: '/admin/manage-group/',
            component: () => import('/app/src/pages/admin/manage-group/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'manage-user',
        /* internal name: '/admin/manage-user' */
        /* no component */
        children: [
          {
            path: '',
            name: '/admin/manage-user/',
            component: () => import('/app/src/pages/admin/manage-user/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'profile',
        /* internal name: '/admin/profile' */
        /* no component */
        children: [
          {
            path: '',
            name: '/admin/profile/',
            component: () => import('/app/src/pages/admin/profile/index.vue'),
            /* no children */
          }
        ],
      }
    ],
    meta: {
      "requiresAuth": true
    }
  },
  {
    path: '/apk',
    name: '/apk',
    component: () => import('/app/src/pages/apk.vue'),
    children: [
      {
        path: '',
        name: '/apk/',
        component: () => import('/app/src/pages/apk/index.vue'),
        /* no children */
      },
      {
        path: 'agent',
        /* internal name: '/apk/agent' */
        /* no component */
        children: [
          {
            path: '',
            name: '/apk/agent/',
            component: () => import('/app/src/pages/apk/agent/index.vue'),
            /* no children */
          },
          {
            path: 'form',
            name: '/apk/agent/form',
            component: () => import('/app/src/pages/apk/agent/form.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/app',
    name: '/app',
    component: () => import('/app/src/pages/app.vue'),
    children: [
      {
        path: '',
        name: '/app/',
        component: () => import('/app/src/pages/app/index.vue'),
        /* no children */
      },
      {
        path: 'admin',
        /* internal name: '/app/admin' */
        /* no component */
        children: [
          {
            path: 'dashboard-user',
            /* internal name: '/app/admin/dashboard-user' */
            /* no component */
            children: [
              {
                path: '',
                name: '/app/admin/dashboard-user/',
                component: () => import('/app/src/pages/app/admin/dashboard-user/index.vue'),
                /* no children */
              },
              {
                path: ':id',
                name: '/app/admin/dashboard-user/[id]',
                component: () => import('/app/src/pages/app/admin/dashboard-user/[id].vue'),
                /* no children */
              },
              {
                path: 'detail',
                name: '/app/admin/dashboard-user/detail',
                component: () => import('/app/src/pages/app/admin/dashboard-user/detail.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'manage-collection',
            /* internal name: '/app/admin/manage-collection' */
            /* no component */
            children: [
              {
                path: '',
                name: '/app/admin/manage-collection/',
                component: () => import('/app/src/pages/app/admin/manage-collection/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'manage-data',
            /* internal name: '/app/admin/manage-data' */
            /* no component */
            children: [
              {
                path: '',
                name: '/app/admin/manage-data/',
                component: () => import('/app/src/pages/app/admin/manage-data/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'manage-feedback',
            /* internal name: '/app/admin/manage-feedback' */
            /* no component */
            children: [
              {
                path: '',
                name: '/app/admin/manage-feedback/',
                component: () => import('/app/src/pages/app/admin/manage-feedback/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'manage-group',
            /* internal name: '/app/admin/manage-group' */
            /* no component */
            children: [
              {
                path: '',
                name: '/app/admin/manage-group/',
                component: () => import('/app/src/pages/app/admin/manage-group/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'manage-tenant',
            /* internal name: '/app/admin/manage-tenant' */
            /* no component */
            children: [
              {
                path: '',
                name: '/app/admin/manage-tenant/',
                component: () => import('/app/src/pages/app/admin/manage-tenant/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'manage-tools',
            /* internal name: '/app/admin/manage-tools' */
            /* no component */
            children: [
              {
                path: '',
                name: '/app/admin/manage-tools/',
                component: () => import('/app/src/pages/app/admin/manage-tools/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'manage-user',
            /* internal name: '/app/admin/manage-user' */
            /* no component */
            children: [
              {
                path: '',
                name: '/app/admin/manage-user/',
                component: () => import('/app/src/pages/app/admin/manage-user/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'profile',
            /* internal name: '/app/admin/profile' */
            /* no component */
            children: [
              {
                path: '',
                name: '/app/admin/profile/',
                component: () => import('/app/src/pages/app/admin/profile/index.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'agent',
        /* internal name: '/app/agent' */
        /* no component */
        children: [
          {
            path: '',
            name: '/app/agent/',
            component: () => import('/app/src/pages/app/agent/index.vue'),
            /* no children */
          },
          {
            path: 'detail',
            name: '/app/agent/detail',
            component: () => import('/app/src/pages/app/agent/detail.vue'),
            children: [
              {
                path: '',
                name: '/app/agent/detail/',
                component: () => import('/app/src/pages/app/agent/detail/index.vue'),
                /* no children */
              },
              {
                path: 'analitycs',
                name: '/app/agent/detail/analitycs',
                component: () => import('/app/src/pages/app/agent/detail/analitycs.vue'),
                /* no children */
              },
              {
                path: 'knowledge',
                name: '/app/agent/detail/knowledge',
                component: () => import('/app/src/pages/app/agent/detail/knowledge.vue'),
                /* no children */
              },
              {
                path: 'logs',
                name: '/app/agent/detail/logs',
                component: () => import('/app/src/pages/app/agent/detail/logs.vue'),
                /* no children */
              },
              {
                path: 'settings',
                name: '/app/agent/detail/settings',
                component: () => import('/app/src/pages/app/agent/detail/settings.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'form',
            name: '/app/agent/form',
            component: () => import('/app/src/pages/app/agent/form.vue'),
            /* no children */
          },
          {
            path: 'management',
            name: '/app/agent/management',
            component: () => import('/app/src/pages/app/agent/management.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'chart',
        name: '/app/chart',
        component: () => import('/app/src/pages/app/chart.vue'),
        /* no children */
      },
      {
        path: 'conversation',
        /* internal name: '/app/conversation' */
        /* no component */
        children: [
          {
            path: '',
            name: '/app/conversation/',
            component: () => import('/app/src/pages/app/conversation/index.vue'),
            /* no children */
          },
          {
            path: 'credits-history',
            name: '/app/conversation/credits-history',
            component: () => import('/app/src/pages/app/conversation/credits-history.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dashboard',
        /* internal name: '/app/dashboard' */
        /* no component */
        children: [
          {
            path: '',
            name: '/app/dashboard/',
            component: () => import('/app/src/pages/app/dashboard/index.vue'),
            /* no children */
          },
          {
            path: 'analytics',
            name: '/app/dashboard/analytics',
            component: () => import('/app/src/pages/app/dashboard/analytics.vue'),
            /* no children */
          },
          {
            path: 'preview',
            name: '/app/dashboard/preview',
            component: () => import('/app/src/pages/app/dashboard/preview.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'data-explorer',
        name: '/app/data-explorer',
        component: () => import('/app/src/pages/app/data-explorer.vue'),
        /* no children */
      },
      {
        path: 'fact-checking',
        name: '/app/fact-checking',
        component: () => import('/app/src/pages/app/fact-checking.vue'),
        /* no children */
      },
      {
        path: 'insights-explorer',
        name: '/app/insights-explorer',
        component: () => import('/app/src/pages/app/insights-explorer.vue'),
        /* no children */
      },
      {
        path: 'pdf',
        name: '/app/pdf',
        component: () => import('/app/src/pages/app/pdf.vue'),
        /* no children */
      },
      {
        path: 'prompt',
        /* internal name: '/app/prompt' */
        /* no component */
        children: [
          {
            path: '',
            name: '/app/prompt/',
            component: () => import('/app/src/pages/app/prompt/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'report',
        /* internal name: '/app/report' */
        /* no component */
        children: [
          {
            path: '',
            name: '/app/report/',
            component: () => import('/app/src/pages/app/report/index.vue'),
            /* no children */
          },
          {
            path: 'presentation',
            name: '/app/report/presentation',
            component: () => import('/app/src/pages/app/report/presentation.vue'),
            /* no children */
          },
          {
            path: 'preview',
            name: '/app/report/preview',
            component: () => import('/app/src/pages/app/report/preview.vue'),
            /* no children */
          },
          {
            path: 'trashed',
            name: '/app/report/trashed',
            component: () => import('/app/src/pages/app/report/trashed.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'share',
        /* internal name: '/app/share' */
        /* no component */
        children: [
          {
            path: '',
            name: '/app/share/',
            component: () => import('/app/src/pages/app/share/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: '/app/share/[id]',
            component: () => import('/app/src/pages/app/share/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'statistical-data',
        name: '/app/statistical-data',
        component: () => import('/app/src/pages/app/statistical-data.vue'),
        children: [
          {
            path: 'category',
            name: '/app/statistical-data/category',
            component: () => import('/app/src/pages/app/statistical-data/category.vue'),
            /* no children */
          },
          {
            path: 'detail',
            name: '/app/statistical-data/detail',
            component: () => import('/app/src/pages/app/statistical-data/detail.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'test',
        name: '/app/test',
        component: () => import('/app/src/pages/app/test.vue'),
        /* no children */
      }
    ],
    meta: {
      "requiresAuth": true
    }
  },
  {
    path: '/auth',
    name: '/auth',
    component: () => import('/app/src/pages/auth.vue'),
    children: [
      {
        path: 'callback',
        name: '/auth/callback',
        component: () => import('/app/src/pages/auth/callback.vue'),
        /* no children */
        meta: {
          "requiresAuth": false
        }
      },
      {
        path: 'login',
        name: '/auth/login',
        component: () => import('/app/src/pages/auth/login.vue'),
        /* no children */
      },
      {
        path: 'logout',
        name: '/auth/logout',
        component: () => import('/app/src/pages/auth/logout.vue'),
        /* no children */
        meta: {
          "requiresAuth": false
        }
      },
      {
        path: 'signup',
        name: '/auth/signup',
        component: () => import('/app/src/pages/auth/signup.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/contact-sales',
    name: '/contact-sales',
    component: () => import('/app/src/pages/contact-sales.vue'),
    /* no children */
    meta: {
      "requiresAuth": false
    }
  },
  {
    path: '/feedback',
    name: '/feedback',
    component: () => import('/app/src/pages/feedback.vue'),
    /* no children */
  },
  {
    path: '/file-not-found',
    name: '/file-not-found',
    component: () => import('/app/src/pages/file-not-found.vue'),
    /* no children */
  },
  {
    path: '/home',
    name: '/home',
    component: () => import('/app/src/pages/home.vue'),
    children: [
      {
        path: '',
        name: '/home/',
        component: () => import('/app/src/pages/home/index.vue'),
        /* no children */
      }
    ],
    meta: {
      "requiresAuth": true
    }
  },
  {
    path: '/iframe',
    /* internal name: '/iframe' */
    /* no component */
    children: [
      {
        path: '',
        name: '/iframe/',
        component: () => import('/app/src/pages/iframe/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/index1',
    name: '/index1',
    component: () => import('/app/src/pages/index1.vue'),
    /* no children */
  },
  {
    path: '/report',
    name: '/report',
    component: () => import('/app/src/pages/report.vue'),
    children: [
      {
        path: '',
        name: '/report/',
        component: () => import('/app/src/pages/report/index.vue'),
        /* no children */
      },
      {
        path: 'create-with-ai',
        name: '/report/create-with-ai',
        component: () => import('/app/src/pages/report/create-with-ai.vue'),
        /* no children */
        meta: {
          "requiresAuth": true
        }
      },
      {
        path: 'our-project',
        name: '/report/our-project',
        component: () => import('/app/src/pages/report/our-project.vue'),
        /* no children */
      },
      {
        path: 'our-template',
        name: '/report/our-template',
        component: () => import('/app/src/pages/report/our-template.vue'),
        /* no children */
      },
      {
        path: 'presentation',
        /* internal name: '/report/presentation' */
        /* no component */
        children: [
          {
            path: '',
            name: '/report/presentation/',
            component: () => import('/app/src/pages/report/presentation/index.vue'),
            /* no children */
          },
          {
            path: 'preview',
            name: '/report/presentation/preview',
            component: () => import('/app/src/pages/report/presentation/preview.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'template',
        /* internal name: '/report/template' */
        /* no component */
        children: [
          {
            path: '',
            name: '/report/template/',
            component: () => import('/app/src/pages/report/template/index.vue'),
            /* no children */
          },
          {
            path: ':slug',
            name: '/report/template/[slug]',
            component: () => import('/app/src/pages/report/template/[slug].vue'),
            /* no children */
          }
        ],
      }
    ],
    meta: {
      "requiresAuth": true
    }
  }
]
